// import axios from 'axios'
import create from 'zustand'
import { persist } from 'zustand/middleware'
import produce from "immer";

// const UserStore = create((set) => ({
//     user: null,
//     setUser: (data) => set({user : data})
// }))

const AuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            setUser: (data) => set({ user: data }),
            logOut: () => set({
                user: null
            })
        }),
        {
            name: 'AuthPersist',
            getStorage: () => localStorage,
            // serialize: (state) => btoa(JSON.stringify(state))
        }
    )
);

const NotifStore = create((set) => ({
    pemberitahuans: [],
    addPemberitahuan: (obj) =>
        set(produce((draft) => {
            draft.pemberitahuans.push(obj)
        })),
    resetPemberitahuans: () => set({ pemberitahuans: [] })
}))

export { AuthStore, NotifStore } 